
<div class="summarycontent">
      <table>
        <tr>
          <td class="summarycell" style="font-weight: bold">
            Importo dovuto
          </td>
  <!--        <td class="summarycell">
            IVA dovuta
          </td>
    -->      <td class="summarycell" style="font-weight: bold">
            Importo pagato
          </td>
<!--          <td class="summarycell">
            IVA pagata
          </td>
-->          <td class="summarycell" style="font-weight: bold">
            Saldo
          </td>
        </tr>
        <tr>
          <td class="summarycell">
            {{importodovutocommessa}}
          </td>
  <!--        <td class="summarycell">
            {{ivadovutacommessa}}
          </td>
  -->        <td class="summarycell">
            {{importopagatocommessa}}
          </td>
  <!--        <td class="summarycell">
            {{ivapagatacommessa}}
          </td>
    -->      <td class="summarycell">
            {{saldocommessa}}
          </td>
        </tr>
      </table>
</div>
      <mat-card>
          <mat-card-header>
              <mat-card-title>Aggiungi pagamento</mat-card-title>
          </mat-card-header>

      <mat-card-content class="content">



        <form [formGroup]="registerForm" (ngSubmit)="save()">

          <mat-form-field appearance="fill" style="padding-right:10px">
              <mat-label class="text-sm">Azienda</mat-label>
              <input matInput placeholder="Azienda" formControlName="selectedValueAzienda" name="selectedValueAzienda" readonly>
          </mat-form-field>

          <mat-form-field appearance="fill" style="padding-right:10px">
              <mat-label class="text-sm">Commessa</mat-label>
              <input matInput placeholder="Commessa" formControlName="selectedValueCommessa" name="selectedValueCommessa" readonly>
          </mat-form-field>

          <mat-form-field appearance="fill" style="padding-right:10px">
            <mat-label class="text-sm">Tipo pagamento</mat-label>
            <mat-select formControlName="selectedValueTipopagamento" name="selectedValueTipopagamento" class="text-sm">
              <mat-option *ngFor="let tipopagamento of tipipagamento" [value]="tipopagamento.Id">
                {{tipopagamento.Nome}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" style="padding-right:10px">
            <mat-label class="text-sm">Metododo di pagamento</mat-label>
            <mat-select formControlName="selectedValueMetodopagamento" name="selectedValueMetodopagamento" class="text-sm">
              <mat-option *ngFor="let metodopagamento of metodipagamento" [value]="metodopagamento.Id">
                {{metodopagamento.Nome}}
              </mat-option>
            </mat-select>
          </mat-form-field>

         <mat-form-field [style.display]="isHidden()"  class="example-full-width">
                   <mat-label class="text-sm">Id</mat-label>
                   <input matInput placeholder="Id" formControlName="Id" name="Id" readonly>
         </mat-form-field>

         <mat-form-field style="minwidth=800px; width=100%">
                   <mat-label class="text-sm">Data pagamento</mat-label>
                   <input matInput [matDatepicker]="startpicker"
                     placeholder="Data pagamento"
                     formControlName="Datapagamento"
                     name="Datapagamento" required>
                   <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
                   <mat-datepicker #startpicker startView="month" ></mat-datepicker>
         </mat-form-field>

         <mat-form-field class="example-full-width">
                   <mat-label class="text-sm">Importo</mat-label>
                   <input matInput placeholder="Importo" formControlName="Importo" name="Importo" (keyup)="manageChangeImporto($event)">
         </mat-form-field>

         <mat-form-field appearance="fill" style="padding-right:10px">
           <mat-label class="text-sm">Documento fiscale</mat-label>
           <mat-select formControlName="selectedValueDocfiscale" name="selectedValueDocfiscale" class="text-sm">
             <mat-option *ngFor="let docfiscale of docfiscali" [value]="docfiscale">
               {{docfiscale}}
             </mat-option>
           </mat-select>
         </mat-form-field>

         <mat-form-field style="height:200px" class="example-full-width">

                   <textarea matInput
                       cdkTextareaAutosize placeholder="..." formControlName="Note" name="Note"
                       #autosize="cdkTextareaAutosize"
                       cdkAutosizeMinRows="1"
                       cdkAutosizeMaxRows="5"></textarea>
         </mat-form-field>

        </form>




      </mat-card-content>

      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="save()">Salva</button>
            </td>
            <td>
              <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
